"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactIntl = require("react-intl");

var _validation = require("../../../_helpers/validation");

var _StatusMessage = _interopRequireDefault(require("./StatusMessage"));

var _ViewImage = _interopRequireDefault(require("./ViewImage"));

var _EditImage = _interopRequireDefault(require("./EditImage"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const Wrapper = _styledComponents.default.div.withConfig({
  displayName: "Wrapper"
})(["width:100%;"]);

class Main extends _react.default.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "wrapperRef", _react.default.createRef());

    _defineProperty(this, "state", {
      imgFile: null,
      invalidImgError: false
    });

    _defineProperty(this, "messages", (0, _reactIntl.defineMessages)({
      error1: {
        "id": "ProfileImageEditor.error1",
        "defaultMessage": "An error occured. Please try again later"
      },
      error2: {
        "id": "ProfileImageEditor.error2",
        "defaultMessage": "Please upload a valid image file under 5 mb."
      }
    }));

    _defineProperty(this, "_updateImgFile", imgFile => {
      this.setState({
        imgFile
      });
    });

    _defineProperty(this, "_photoChangeHandler", e => {
      const imgFile = e.target.files[0];

      if ((0, _validation.validImage)(imgFile)) {
        this._updateImgFile(imgFile);
      } else {
        this.setState({
          invalidImgError: true
        });
      }
    });

    _defineProperty(this, "_handleImgSubmit", imgData => {
      const _submitImgHandler = this.props._submitImgHandler;
      this.setState({
        invalidImgError: false
      });

      _submitImgHandler(imgData);
    });

    _defineProperty(this, "_renderEditor", () => {
      const imgSrc = this.props.imgSrc;
      const imgFile = this.state.imgFile;

      if (imgFile) {
        return /*#__PURE__*/_react.default.createElement(_EditImage.default, {
          _cancelHandler: this._updateImgFile,
          _submitHandler: this._handleImgSubmit,
          imgFile: imgFile,
          size: this.wrapperRef.current.offsetWidth
        });
      }

      return /*#__PURE__*/_react.default.createElement(_ViewImage.default, {
        _handlePhotoChange: this._photoChangeHandler,
        imgSrc: imgSrc
      });
    });

    _defineProperty(this, "_renderError", () => {
      const _this$props = this.props,
            formatMessage = _this$props.intl.formatMessage,
            error = _this$props.error;
      const invalidImgError = this.state.invalidImgError;

      if (error) {
        const status = {
          message: formatMessage(this.messages.error1),
          type: 'error'
        };
        return /*#__PURE__*/_react.default.createElement(_StatusMessage.default, {
          status: status
        });
      }

      if (invalidImgError) {
        const status = {
          message: formatMessage(this.messages.error2),
          type: 'error'
        };
        return /*#__PURE__*/_react.default.createElement(_StatusMessage.default, {
          status: status
        });
      }

      return null;
    });
  }

  componentDidUpdate(prevProps) {
    const prevImgSrc = prevProps.imgSrc;
    const imgSrc = this.props.imgSrc;

    if (imgSrc !== prevImgSrc) {
      // Update success
      // Show viewer
      this._updateImgFile(null);
    }
  }

  render() {
    return /*#__PURE__*/_react.default.createElement(Wrapper, {
      ref: this.wrapperRef
    }, this._renderEditor(), this._renderError());
  }

}

Main.propTypes = {
  /** Accepts argument of Base 64 encoded image data */
  _submitImgHandler: _propTypes.default.func.isRequired,
  error: _propTypes.default.bool,
  imgSrc: _propTypes.default.string.isRequired,
  intl: _propTypes.default.shape({
    formatMessage: _propTypes.default.func.isRequired
  }).isRequired
};
Main.defaultProps = {
  error: false
};

var _default = (0, _reactIntl.injectIntl)(Main);

exports.default = _default;